import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useNavigation } from 'msp-integrations'
import SelectedFilterElement from './SelectedFilterElement'
import * as T from '@/pages/product-list/ProductList.types'
import { EXCLUDED_REFINEMENTS } from './Filters'
import { isCategoryRefinement, getBaseCategory } from '../index'

const SelectedFilters = ({
  className = '',
  refinements,
  selectedRefinements,
  toggleFilter
}: T.SelectedFiltersProps) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigation()
  const params = useParams<T.ProductListParams>()
  const [selectedFilters, setSelectedFilters] = useState<
    T.SelectedFilterType[]
  >([])

  const resetFilters = () => {
    const baseCategory = selectedFilters.find((filter) => filter?.baseCategory)
    const redirectCategory = baseCategory
      ? baseCategory?.baseCategory
      : params?.categoryId
    setSelectedFilters([])
    navigate(`/shop/${redirectCategory}`)
  }

  const getLabel = (attributeId: string, value: string) => {
    const filter = refinements.find(
      (refinement) => refinement.attributeId === attributeId
    )
    let filterLabel

    if (filter) {
      const filterElement = filter.values?.find(
        (element: T.RefinementValue) => element.value === value
      )
      filterLabel = filterElement?.label
    }

    return filterLabel || value
  }

  const getSelectedRefinements = () => {
    const selectedFilterLabels: T.SelectedFilterType[] = []
    for (const key in selectedRefinements) {
      if (key !== 'htype' && !EXCLUDED_REFINEMENTS.includes(key)) {
        const filters = selectedRefinements[key].split('|')
        filters?.forEach((filter) => {
          if (key === 'cgid') {
            const categoryRefinement = Object.values(refinements).find(
              (refinement) => isCategoryRefinement(refinement)
            )
            const baseCategory = getBaseCategory(categoryRefinement)
            if (baseCategory?.values?.find((value) => value.value === filter)) {
              const selected: T.SelectedFilterType = {
                label: getLabel(key, filter),
                value: filter,
                attributeId: key,
                baseCategory: baseCategory?.value
              }
              selectedFilterLabels.push(selected)
            }
          } else {
            const selected: T.SelectedFilterType = {
              label: getLabel(key, filter),
              value: filter,
              attributeId: key
            }
            selectedFilterLabels.push(selected)
          }
        })
      }
    }
    return selectedFilterLabels
  }

  useEffect(() => {
    const selectedFilterLabels: T.SelectedFilterType[] =
      getSelectedRefinements()
    setSelectedFilters(selectedFilterLabels)
  }, [selectedRefinements])

  if (selectedFilters.length <= 0) return null

  return (
    <div className={`flex flex-wrap items-center ${className}`}>
      {selectedFilters?.map((filter, idx) => {
        return (
          <SelectedFilterElement
            key={idx}
            attributeId={filter.attributeId}
            value={filter.value}
            label={filter.label}
            toggleFilter={toggleFilter}
            parentCategory={filter?.baseCategory}
          />
        )
      })}
      <div
        className={
          'font-Roboto text-14 tracking-0  text-grayRegular mb-2 flex h-8 cursor-pointer items-center whitespace-nowrap'
        }
        onClick={() => resetFilters()}
      >
        {formatMessage({
          defaultMessage: 'Clear all filters',
          id: 'msp.product_list.selected_refinements.clear_all'
        })}
      </div>
    </div>
  )
}

export default SelectedFilters
